import { createPortal } from 'react-dom';

export interface PortalProps {
  children: React.ReactNode;
  /** Target element to render portal into. Defaults to document.body */
  target?: HTMLElement | null;
}

export function Portal({ children, target }: PortalProps) {
  return createPortal(children, target || document.body);
}
